

document.addEventListener("DOMContentLoaded", function () {
  const richTextBlocks = document.querySelectorAll('.rich-text');

  richTextBlocks.forEach(function (richText) {
    const childDiv = richText.querySelector('.rich-text__content.rte');
    
    if (childDiv && childDiv.innerHTML.trim() === '') {
      richText.style.display = 'none';
    }
  });
});
